<template lang="html">

  <div class="header-wrapper" :style="style.colorDarkBlack">

    <section class="header row-between" :min="isMin">

      <span class="fake-bg"></span>

      <div class="contenedor-logo row-start">

        <router-link class="logo row-start" to="/">
          <img :src="logoselected" alt="Logo" :size="logosize">
        </router-link>

      </div>

      <div class="contenedor-texto row-end" v-if="logged">

        <router-link v-if="!!personales & isAlumno" class="nombre" to="/cv">{{$t('header.hola')}} {{personales}}</router-link>
        <router-link v-if="!!personales & isEmpresa" class="nombre" to="/mi-perfil">{{$t('header.hola')}} {{personales}}</router-link>

        <idioma v-if="brand.languagebydefault"></idioma>

        <notificaciones></notificaciones>

        <button class="show-menu" @click="showMenu= true" >
          <span></span>
          <span></span>
          <span></span>
        </button>

      </div>

    </section>

    <section class="menu row-center" :show="showMenu">

      <div class="left row-center">
        <span class="logo-menu-container" @click="hideMenu">
          <router-link to="/">
            <img :src="logo" alt="Logo" class="logo-menu" :size="logosize"></router-link>
        </span>
      </div>

      <div class="right row-center" :style="style.backgroundWhite">

        <button class="cerrar-menu" @click="showMenu= false">✕</button>

        <nav>

          <div class="mains">

            <span @click="hideMenu">
              <router-link to="/" class="logo-movil">
                <img :src="logocolor" alt="Logo" :size="logosize">
              </router-link>
            </span>

            <template v-if="isAlumno">
              <template v-if="!!ofertasParams.practicas.numTotal && isAlumno && brand.siteAlumnos.showBuscarOfertas">
                <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.ofertas_practicas')" class="main">{{$t('header.oferta_practicas')}}</router-link>
              </template>

              <template v-if="!!ofertasParams.empleo.numTotal">
                <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.ofertas_empleo')" class="main">{{$t('header.oferta_empleo')}}</router-link>
              </template>
              <!-- <template v-if="hasPracticas && showPropuestaPracticas && !soloCiclosUAX">
                <router-link @click.native="hideMenu" class="main" :style="style.fontSecondary" :to="$t('enlaces.propuesta_practicas')">{{$t('header.propuesta_practicas')}}</router-link>
              </template> -->
              <router-link v-if="isAlumno && brand.siteAlumnos.showMisEncuestas && encuestas.length > 0" @click.native="hideMenu" :style="style.fontSecondary" to="/#encuestas" class="main">Mis encuestas
              </router-link>

              <router-link v-if="isAlumno && brand.siteAlumnos.showMisCandidaturas" @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mis_candidaturas')" class="main">{{$t('header.candidaturas')}}</router-link>

              <router-link @click.native="hideMenu" :style="style.fontSecondary" v-if="hasPracticas" :to="$t('enlaces.mis_practicas')" class="main">{{$t('header.practicas')}}</router-link>

              <template v-if="brand.hasProgramaPracticasActivo">
                <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.programapracticasactivos')" class="main">{{$t('header.programas')}}
                </router-link>
              </template>
              <router-link v-if="isEmpresa && brand.siteEmpresa.showMisEncuestas" @click.native="hideMenu" :style="style.fontSecondary" to="/#encuestas" class="main">{{$t('header.encuestas')}}
              </router-link>


              <router-link v-if="brand.hasEventos" @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.eventos')" class="main">{{$t('header.eventos')}}</router-link>


              <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.cv')" class="main">{{$t('header.mi_cv')}}</router-link>

              <router-link v-if="brand.hasGuiasOrientacion" @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.guiaOrientacion')" class="main">{{$t('header.guias_orientacion')}}</router-link>


            </template>



            <template v-if="isEmpresa">


              <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mis_ofertas')" class="main">{{$t('header.mis_ofertas')}}
              </router-link>

              <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.nueva_oferta')" class="main">{{$t('header.nueva_oferta')}}
              </router-link>

              <template v-if="showPropuestaPracticas && brand.siteEmpresa.showPropuestaPracticas && brand.siteAlumnos.showPropuestaPracticas">
                <router-link @click.native="hideMenu" class="main" :style="style.fontSecondary" :to="$t('enlaces.propuesta_practicas')">{{$t('header.propuesta_practicas')}}</router-link>
              </template>

              <template v-if="brand.canCambiarPracticas">
                <router-link @click.native="hideMenu" class="main" :style="style.fontSecondary" :to="$t('enlaces.solicitarcambiopracticas')">{{$t('header.solicitar_cambio_practicas')}}</router-link>
              </template>

              <template v-if="brand.hasProgramaPracticasActivo">
                <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.programapracticasactivos')" class="main">{{$t('header.programas')}}
                </router-link>
              </template>

              <router-link @click.native="hideMenu" :style="style.fontSecondary" class="main" :to="$t('enlaces.documentacion')">{{$t('header.documentacion')}}
              </router-link>
              <template v-if="hasMenuEducacion && solicitudesEducacion.length != 0">
                <router-link @click.native="hideMenu" :style="style.fontSecondary" class="main" :to="$t('enlaces.practicaseducacion')">{{$t('header.solicitudes_practicas_educacion')}}
                </router-link>
              </template>





              <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mi_empresa')" class="main">{{$t('header.mi_empresa')}}
              </router-link>

            </template>


            <router-link @click.native="hideMenu" class="logout" :style="style.fontSecondary" :to="$t('enlaces.ayuda')" v-if="brand.hashelp && isAlumno">{{$t('header.ayuda')}}</router-link>

            <router-link @click.native="hideMenu" class="logout" :style="style.fontSecondary" :to="$t('enlaces.logout')">{{$t('header.cerrar_sesion')}}</router-link>
            <a v-if="brand.canBorrarCuenta & isAlumno" class="eraseAcount" :style="style.fontSecondary" @click="showpopupborrarcuenta = true">{{$t('header.solicitar_baja')}}</a>
          </div>

          <toggle-dark-mode v-if="islocalhost"></toggle-dark-mode>

        </nav>



      </div>

    </section>

    <popup-borrar-cuenta v-if="showpopupborrarcuenta" @hide="showpopupborrarcuenta = false"></popup-borrar-cuenta>

  </div>

</template>

<script lang="js">

  import { mapActions, mapGetters } from 'vuex';

  import Notificaciones from '@/components/parts/notificaciones'

  import popUpBorrarCuenta from '@/components/parts/popup-borrar-cuenta';
  import toggledarkmode from '@/components/parts/toggledarkmode';

  import router from '@/router';

  import Vue from 'vue'
  import Vue2TouchEvents from 'vue2-touch-events'


  import idioma from '@/components/parts/idioma-header';

  Vue.use(Vue2TouchEvents)



  export default {
    name: 'app-header',
    data() {
      return {
        showMenu: false,
        nombre: '',
        showpopupborrarcuenta: false
      }
    },
    mounted() {

      var that = this;

      this.thingsOfHeader();

      $(window).scroll(function (event) {
        that.thingsOfHeader();
      });

    },
    methods: {
      ...mapActions(['logout', 'toggleDarkSide']),
      thingsOfHeader: function () {
        let distance = $(window).scrollTop();
        let when = ($(window).width() > 768) ? 120 : 70;
        (distance >= when) ? $(".header").addClass('min') : $(".header").removeClass('min');
      },
      hideMenu: function () {
        this.showMenu = false;
      },
      showDisponible: function () {
        alert('Muy pronto disponible')
      }
    },
    computed: {
      ...mapGetters({
        isAlumno: 'isAlumno',
        isEmpresa: 'isEmpresa',
        style: 'getStyles',
        colors: 'basicColors',
        logo: 'getLogo',
        logocolor: 'getLogoColor',
        logoencabezado: 'getLogoEncabezado',
        logosize: 'getLogoSize',
        personales: 'getUserName',
        logged: 'getLogged',
        ofertasParams: 'getParamsOfertas',
        darkmode: 'getDarkSide',
        hasPracticas: 'hasPracticas',
        getShowPropuestaPracticas: 'getShowPropuestaPracticas',
        version: 'getVersion',
        brand: 'getBrand',
        inproduction: 'getInProduction',
        hasMenuEducacion: 'getMenuEducacion',
        solicitudesEducacion: 'getsolicitudesEducacion',
        soloCiclosUAX: 'getsoloCiclosUAX', 
        encuestas :"getEncuestas"
      }),
      isMin: function () {
        let allow = [
          'ficha_oferta_alumno_empleo',
          'ficha_oferta_alumno_practicas',
          'ficha_oferta_empresa',
          'ficha_encuestas',
          'visor_oferta',
          'ficha-solicitudes-educacion'
        ];
        return (allow.some(el => this.$route.name == el));
      },
      ownstyles: function () {
        return {
          colorNombre: {
            color: (!!this.colors.fontAlternative) ? this.colors.fontAlternative : this.colors.white
          },
          colorMenu: {
            color: (!!this.colors.fontAlternative) ? this.colors.fontAlternative : this.colors.white
          }
        }
      },
      logoselected() {
        let logo = (!!this.logoencabezado) ? this.logoencabezado : this.logo;

        if (this.darkmode) {
          logo = this.brand.logodarkmode;
        }

        return logo;
      },
      showPropuestaPracticas() {
        let show;

        if (typeof this.getShowPropuestaPracticas == 'string') {
          show = (this[this.getShowPropuestaPracticas]);
        } else {
          show = this.getShowPropuestaPracticas
        }

        return show;
      },
      islocalhost() {
        return (window.location.hostname == 'localhost');
      }
    },
    components: {
      'notificaciones': Notificaciones,
      'popup-borrar-cuenta': popUpBorrarCuenta,
      'toggle-dark-mode': toggledarkmode,
      'idioma': idioma
    },
    watch: {
      '$route': function () {
        this.showMenu = false;
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/css/colors.scss";
</style>


// WEBPACK FOOTER //
// src/components/parts/header.vue